import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, EMPTY } from 'rxjs';
import { ERROR_PROVIDER } from '../../../core/services/error.service';

export const catchErrorOfResolve = <T>(resolver: ResolveFn<T>): ResolveFn<T> => {
	return (route, state) => {
		const errorSrv = inject(ERROR_PROVIDER);

		try {
			const result = resolver(route, state);

			// If the resolver returns a Promise
			if (result instanceof Promise) {
				return result.catch((error) => {
					console.error('Resolve error:', error);
					errorSrv.handleError(error, true);
					return undefined as T;
				});
			}

			// If the resolver returns an Observable
			if (result && typeof result === 'object' && 'subscribe' in result) {
				return result.pipe(
					catchError((error) => {
						console.error('Resolve error:', error);
						errorSrv.handleError(error, true);
						return EMPTY;
					}),
				);
			}

			// If it's a synchronous value
			return result;
		} catch (error) {
			console.error('Resolve error:', error);
			errorSrv.handleError(error, true);
			return undefined as T;
		}
	};
};
